import React from 'react'
import { BrowserRouter, Routes, Route } from 'react-router-dom'


//UserPage
import MainLayout from './components/MainLayout'
import HomePage from './components/HomePage'
import Catagories from './components/Catagories'
import Gallery from './components/Gallery'
import AboutUs from './components/AboutUs'
import ProductList from './components/ProductList'

//AdminPage
import AdminHome from './admin/AdminHome'
import AdminAddProduct from './admin/AdminAddProduct'
import AdminViewAllCatagories from './admin/AdminViewAllCatagories'
import AdminProductList from './admin/AdminProductList'
import AdminHeroBanner from './admin/AdminHeroBanner'
import AdminTopProducts from './admin/AdminTopProducts'
import AdminEnquiryDesk from './admin/AdminEnquiryDesk'

//NavBar element
import NavBar from './components/elements/NavBar'

//Footer element
import Footer from './components/elements/Footer'

//ScrollToTop of every page
import ScrollToTop from './components/elements/ScrollToTop'


export default function App() {
  return (
    <div>
      <BrowserRouter>
        <ScrollToTop/>
        <Routes>
          <Route element={<MainLayout/>}>
            <Route exact path="/" element={<HomePage/>} />
            <Route exact path="/Catagories" element={<Catagories/>} />
            <Route exact path="/Gallery" element={<Gallery/>} />
            <Route exact path="/AboutUs" element={<AboutUs/>} />
            <Route exact path="/ProductList" element={<ProductList/>} />
          </Route>

          <Route exact path="/admin-home" element={<AdminHome/>} />
          <Route exact path="/AdminAddProduct" element={<AdminAddProduct/>} />
          <Route exact path="/AdminViewAllCatagories" element={<AdminViewAllCatagories/>} />
          <Route exact path="/AdminProductList/:value" element={<AdminProductList/>} />
          <Route exact path="/AdminHeroBanner" element={<AdminHeroBanner/>} />
          <Route exact path="/AdminTopProducts" element={<AdminTopProducts/>} />
          <Route exact path="/AdminEnquiryDesk" element={<AdminEnquiryDesk/>} />
        </Routes>
      </BrowserRouter>
    </div>
  )
}
